import { render } from "./ModalEditSnils.vue?vue&type=template&id=19d85d6a"
import script from "./ModalEditSnils.vue?vue&type=script&lang=js"
export * from "./ModalEditSnils.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__